import React from 'react';
import styled from 'styled-components/native';

import { activeOpacity } from '@src/configuration/constants';

import { Props } from './types';

const Container = styled.TouchableOpacity.attrs({
  activeOpacity,
})`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colors.placeholder};
`;

const Component: React.FC<Props> = ({ source, onPress }) => {
  return (
    <Container onPress={onPress}>
      <img className="cover" alt="Cover" src={source.uri} />
    </Container>
  );
};

Component.displayName = 'Cover';

export default Component;
